export default __webpack_public_path__ + "static/media/darkpassenger.a7395532.jpg";